import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  CONSENT_URL,
  DASHBOARD_URL,
  DOCUMENTS_URL,
  HOME_URL,
  LOGIN_URL,
  AUTH_LOGIN_URL,
  LOGOUT_URL2,
  // MESSAGING_URL,
  CASES_URL,
  ADMIN_URL,
  SERVICEINIT_URL,
  HELP_URL,
  QUESTIONNAIRE_URL,
  IDVALIDATOR_URL,
  MANUALREQUESTQUEUE_URL,
  PAYWALLREQUESTQUEUE_URL,
  SITE_MAINTENANCE_URL,
  APP_UPDATE_URL,
  CASE_UPLOAD_URL,
  PREREGISTER_APPLICANTS_URL,
  PROFORMA_UPLOAD,
  TEST_PARSER,
  POWERBI_URL,
  LOBBY_MESSAGE_URL,
  OVERVIEW_CASES_URL,
  TAXCHAT_SERVICE_INITIATION_URL,
  CONSENT_MANAGEMENT_URL,
} from 'src/constants/constants.js';

/* main features */
import Consent from 'src/ui/features/Consent';
import Documents from 'src/ui/features/Documents';
// import Messaging from 'src/ui/features/Messaging';
import AppUpdate from 'src/ui/features/AppUpdate';
import Admin from 'src/ui/features/Admin';
import ConsentManagement from 'src/ui/features/ConsentManagement';
import ServiceInit from 'src/ui/features/ServiceInit';
import Help from 'src/ui/features/Help';
import Questionnaire from 'src/ui/features/Questionnaire';
//import { routeChange } from './metrics/metricAction';
import TestParser from './ui/features/TestParser'; // this will be removed when questionnaire testing
import requireAuth from 'src/utils/requireAuth';
import { SiteMaintenanceContainer } from 'src/ui/features/Maintenance';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';

//Lazy Load
const Login = lazy(() => import('src/ui/features/Login'));
const Dashboard = lazy(() => import('src/ui/features/Dashboard'));
const Home = lazy(() => import('src/ui/features/Home'));
const Cases = lazy(() => import('src/ui/features/Cases'));
const Overview = lazy(() => import('src/ui/features/Overview'));
const PowerBiLaunch = lazy(() => import('src/ui/features/PowerBiLaunch'));
const PreregisterApplicants = lazy(() => import('src/ui/features/PreregisterApplicants'));
const CaseUpload = lazy(() => import('src/ui/features/CaseUpload'));
const ProformaUpload = lazy(() => import('src/ui/features/ProformaUpload'));
const IdValidator = lazy(() => import('src/ui/features/IdValidator'));
const LobbyMessage = lazy(()=> import('src/ui/features/LobbyMessage'));
const Paywall = lazy(() => import('src/ui/features/Paywall'));
const TaxChatServiceInitiation = lazy(() => import('src/ui/features/TaxChatServiceInitiation'));
// let prevLocation = {};
// history.listen(location => {
//   if (location.pathname !== prevLocation.pathname) {
//     store.dispatch(routeChange(location));
//     prevLocation = location;
//   }
// });

let routes = (
  <Suspense fallback={<ServiceSpinner open={true} />}>
    <Routes>
      <Route path={SITE_MAINTENANCE_URL} element={<SiteMaintenanceContainer />} />
      <Route path={`${CONSENT_URL}/*`} element={React.createElement(requireAuth(Consent))} />
      <Route path={`${QUESTIONNAIRE_URL}/*`} element={React.createElement(requireAuth(Questionnaire))} />
      <Route path={`${DASHBOARD_URL}/*`} element={React.createElement(requireAuth(Dashboard))} />
      <Route path={`${DOCUMENTS_URL}/*`} element={React.createElement(requireAuth(Documents))} />
      <Route path={`${HOME_URL}/*`} element={React.createElement(requireAuth(Home))} />
      {/* <Route path={`${MESSAGING_URL}/*`} element={React.createElement(requireAuth(Messaging))} /> */}
      <Route path={`${OVERVIEW_CASES_URL}/*`} element={React.createElement(requireAuth(Overview))} />
      <Route path={`${CASES_URL}/*`} element={React.createElement(requireAuth(Cases))} />
      <Route path={`${APP_UPDATE_URL}/*`} element={React.createElement(requireAuth(AppUpdate))} />
      <Route path={`${CASE_UPLOAD_URL}/*`} element={React.createElement(requireAuth(CaseUpload))} />
      <Route path={`${PREREGISTER_APPLICANTS_URL}/*`} element={React.createElement(requireAuth(PreregisterApplicants))} />
      <Route path={`${PROFORMA_UPLOAD}/*`} element={React.createElement(requireAuth(ProformaUpload))} />
      <Route path={`${ADMIN_URL}/*`} element={React.createElement(requireAuth(Admin))} />
      <Route path={`${LOBBY_MESSAGE_URL}/*`} element={React.createElement(requireAuth(LobbyMessage))} />
      <Route path={`${HELP_URL}/*`} element={React.createElement(requireAuth(Help))} />
      <Route path={`${POWERBI_URL}/*`} element={React.createElement(requireAuth(PowerBiLaunch))} />
      <Route path={`${SERVICEINIT_URL}/*`} element={React.createElement(requireAuth(ServiceInit))} />
      <Route path={`${TAXCHAT_SERVICE_INITIATION_URL}/*`} element={React.createElement(requireAuth(TaxChatServiceInitiation))} />
      <Route path={`${CONSENT_MANAGEMENT_URL}/*`} element={React.createElement(requireAuth(ConsentManagement))} />
      <Route path={`${IDVALIDATOR_URL}/*`} element={React.createElement(requireAuth(IdValidator))} />
      <Route path={`${MANUALREQUESTQUEUE_URL}/*`} element={React.createElement(requireAuth(IdValidator))} />
      <Route path={`${PAYWALLREQUESTQUEUE_URL}/*`} element={React.createElement(requireAuth(Paywall))} />
      <Route path={TEST_PARSER} element={<TestParser />} />
      <Route path={`${LOGIN_URL}/*`} element={React.createElement(requireAuth(Login, false))} />
      <Route path={`${AUTH_LOGIN_URL}/*`} element={React.createElement(requireAuth(Login, false))} />
      <Route path="*" element={<Navigate to={LOGIN_URL} replace />} />
    </Routes>
  </Suspense>
);

if (sessionStorage.getItem('CN')) {
  routes = (
    <Routes>
      <Route path={`${CONSENT_URL}/*`} element={<Consent />} />
      <Route path={`${LOGOUT_URL2}/*`} element={<Login />} />
      <Route path="*" element={<Navigate to={LOGOUT_URL2} replace />} />
    </Routes>
  );
}

export default routes;
